import { addClassName } from 'utilities';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import {
  EvaluatedGrossIRRCell, GrossIRRCellMap, GrossIRRParserParams, GrossIRRRowData
} from './types';


export const GrossIRRParser = (
  params: GrossIRRParserParams
): GrossIRRCellMap => {
  const { rowConfig, columns } = params;

  const alphabet = alphabetGenerator([], columns.length);
  const cells: GrossIRRCellMap = {};

  rowConfig.forEach((rowItem, rowIndex) => {
    const rowNumber = rowIndex + 1;
    // Skip header row config object
    // Create header cells
    const irrRowData = rowItem as GrossIRRRowData;

    columns.forEach((col, colIndex) => {
      const columnLegend = alphabet[colIndex];
      const cellKey = `${columnLegend}${rowNumber}`;

      if (rowIndex === 0) {
        cells[cellKey] = {
          ...col,
          value: col.value,
          key: cellKey,
          alias: col.alias,
          columnLegend,
          rowNumber,
          expr: col.value,
        } as EvaluatedGrossIRRCell;
        return;
      }

      let value: string | number | null = null;

      if (col.alias === 'fund_name') {
        value = irrRowData.name;
      } else if (col.alias === 'gross_irr') {
        value = irrRowData.grossIrr;
      }

      const baseClassName = col.className ?? '';
      const className = irrRowData.isTotal ? addClassName(baseClassName, 'gross-irr-total-row').trim() : baseClassName;

      cells[cellKey] = {
        ...col,
        value,
        entityId: irrRowData.id,
        key: cellKey,
        alias: col.alias,
        columnLegend,
        rowNumber,
        readOnly: true,
        expr: value?.toString() || '',
        className,
      };
    });
  });

  return cells;
};
